import { useQuery } from "@tanstack/react-query";
import { useForBindingId } from "../../../forBinding";
import api from "../../http";

interface ActivityHistoryParams {
    page: number;
    limit: number;
}

export interface ActivityHistoryData {
    _id: string;
    description: string;
    category: string;
    action: string;
    entityType: string;
    createdAt: string;
}

export interface ActivityHistoryResponse {
    docs: ActivityHistoryData[];
    totalDocs: number;
    limit: number;
    totalPages: number;
    page: number;
    pagingCounter: number;
    hasPrevPage: boolean;
    hasNextPage: boolean;
    prevPage: number | null;
    nextPage: number | null;
}

const ACTION_LABELS: Partial<Record<string, string>> = {
    agricultural_defensive_created: 'Defensivo agrícola criado',
    area_created: 'Área criada',
    sector_created: 'Setor criado',
    support_ticket_created: 'Chamado de suporte criado',
    soil_analysis_created: 'Análise de solo criada',
    parcelling_created: 'Parcelamento criado',
    fertilizer_created: 'Fertilizante agrícola criado',
    farmer_created: 'Produtor rural cadastrado',
};

export const useGetActivityHistory = ({ page = 1, limit = 5 }: ActivityHistoryParams) => {
    const forBinding = useForBindingId();
    const query = useQuery({
        queryKey: ['activity-history', page, limit, forBinding],
        queryFn: async () => {
            const { data } = await api.get<ActivityHistoryResponse>('/activity-history/findAll', {
                params: {
                    page,
                    limit,
                    forBinding,
                }
            });
            return {
                ...data,
                docs: data.docs.map((item) => ({
                    ...item,
                    action: ACTION_LABELS[item.action] ?? item.action,
                })),
            };
        },
    });
    return query;
};
